module.exports = {
	"properties": {
		"beforeRequest": {
			"$ref": "#cacheEntry"
		},
		"afterRequest": {
			"$ref": "#cacheEntry"
		},
		"comment": {
			"type": "string"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/embed-video/~/request/~/har-validator/lib/schemas/cache.json
// module id = 347
// module chunks = 0